/**
 * Page header for every Virtual Submetering route.
 *
 * The module's customer-facing name lives in one place, as a `common`
 * translation key alongside every other module title, rather than hardcoded
 * once per route — six call sites that could otherwise drift, and a rename
 * that could otherwise only be done in English.
 */
import type React from "react"
import { useTranslation } from "react-i18next"

import { PageHeader } from "@/components/nav/page-header"

export const VirtualSubmeteringHeader: React.FC = () => {
  const { t } = useTranslation("common")

  return <PageHeader title={t("moduleTitle.virtualSubmetering")} />
}
